import { Dispatch } from "react";
import { IncomingMessage } from "http";

import { getCartDispensary } from "api/requests/getCartDispensary";
import { getCurrentStatuses } from "api/requests/getCurrentStatuses";
import { retrieveCartServerSide } from "api/requests/retrieveCartServerSide";
import { CountryCode } from "custom-types/CountryCode";
import {
  GET_CART_FAILURE,
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
} from "redux/reducers/cart";
import {
  LOAD_CART_DISPENSARY,
  SET_SCHEDULE_STATUSES,
} from "redux/reducers/cartDispensary";

import { CartContext } from "../custom-types/Cart";

type getCartAndDispensaryOptions = {
  cartContext?: CartContext | null;
  cartId?: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  dispatch: Dispatch<any>;
  domainCountryCode?: CountryCode;
  loadDispensary?: boolean;
  request?: IncomingMessage | null;
  updateOnLoad?: boolean;
};

const getCartAndDispensary = async ({
  cartContext = null,
  cartId = null,
  dispatch,
  domainCountryCode = "US",
  loadDispensary = true,
  request = null,
  updateOnLoad = false,
}: getCartAndDispensaryOptions) => {
  dispatch({
    type: GET_CART_REQUEST,
  });

  const cartResponse = await retrieveCartServerSide({
    cartContext: cartContext,
    cartId: cartId as string,
    domainCountryCode: domainCountryCode,
    request: request,
    updateOnLoad: updateOnLoad,
  });

  if (cartResponse.error) {
    dispatch({
      type: GET_CART_FAILURE,
    });
  } else if (cartResponse.cart) {
    dispatch({
      cart: cartResponse.cart,
      changes: cartResponse.changes,
      type: GET_CART_SUCCESS,
    });
  }

  const cartDispensaryId = cartResponse?.cart?.dispensaryData?.id;
  const cartDispensarySlug = cartResponse.cart?.dispensaryData?.slug;

  if (cartDispensaryId && cartDispensarySlug && loadDispensary) {
    const [dispensaryResponse, currentStatusesReponse] = await Promise.all([
      getCartDispensary(cartDispensaryId),
      getCurrentStatuses(cartDispensarySlug),
    ]);

    dispatch({
      data: dispensaryResponse,
      type: LOAD_CART_DISPENSARY,
    });

    dispatch({
      currentStatuses: currentStatusesReponse,
      type: SET_SCHEDULE_STATUSES,
    });
  }
};

export default getCartAndDispensary;
